enum DeliveryMethod {
	ON_SHORE = 'franco_on_shore',
	ASHORE = 'franco_ashore',
	ON_BOARD = 'franco_on_board',
	AT_WORK = 'franco_at_work',
	UNDER_WATER = 'franco_underwater'
}

export default DeliveryMethod
